// @flow
import { getTime } from 'date-fns';

import { dateUtils } from './date-utils';
import config from '../config/';

type Timestamp = number;

const ONE_MINUTE_TIME_STAMP: number = 60 * 1000;

export const getTimestampFromDate = (stringDate: string, dateFormat: string): Timestamp => {
  let timestamp: Timestamp = getTime(dateUtils.parse(stringDate, dateFormat));
  const localOffset: number = new Date().getTimezoneOffset();
  const twelveHoursTimestamp: number = 60 * 12;
  timestamp += (localOffset + config.timezoneOffsetInMinutes + twelveHoursTimestamp) * ONE_MINUTE_TIME_STAMP;

  return timestamp;
};
